import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../../layout/Leftpanel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getALLGLlist,
  addGLKey,
  importGL,
} from "../../../../service/gl/glService";
import { Button, Modal } from "react-bootstrap";
import * as XLSX from "xlsx";
import instance from "../../../../WebApi/WebApi";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const APP_URL = process.env.REACT_APP_URL;

const GL = () => {

  const { t } = useTranslation();
  const [file, setFile] = useState(null);

  const [jsonResult, setJsonResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [icon, setIcon] = useState("");
  const [show, setShow] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [glData, setGlData] = useState({ key: "", value: "" });
  const [glList, setGlList] = useState([]);
  const [editId, getEditId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = glList?.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(glList?.length / PER_PAGE);

  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setGlData({ key: "", value: "" });
    setShow(false);
  };

  const handleCloseEdit = () => {
    setEditModal(false);
    setGlData({ key: "", value: "" });
  };

  const getEditGL = async (id) => {
    const data = {
      GlId: id,
    };
    setIsLoading(true);
    const response = await instance.post(`/customer/gl/get-gl-by-id`, data);
    setIsLoading(false);
  //  console.log("edit id-->", response);
    // setEditData(response?.data?.data?.gl);
    setGlData({
      key: response?.data?.data?.gl?.key,
      value: response?.data?.data?.gl?.value,
    });
  };

  const handleEdit = (id) => {
    getEditId(id);
    getEditGL(id);
    setEditModal(true);
  };

  const _SUBMIT_ADD = (e) => {
    e.preventDefault();
    if (!glData.key) {
      toast.error("Please enter GL key");
    } else if (!glData.value) {
      toast.error("Please enter GL description");
    } else {
      setIsLoading(true);
      addGLKey({ ...glData, key: glData.key }, (r) => {
        handleClose();

        if (r.success === true) {
          setIsLoading(false);
          getGLDataList();
          toast.success(r.message);
        } else {
          setIsLoading(false);
          handleClose();
          toast.error(r.message);
        }
      });
    }
  };

  useEffect(() => {
    getGLDataList();
  }, []);

  async function getGLDataList() {
    setIsLoading(true);
    getALLGLlist().then(function (result) {
      const response = result?.data;
      setGlList(response?.data?.glList);
      setIsLoading(false);
    });
  }

  function handleChange(event) {
    const file = event.target.files[0];

    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setIsLoading(true);

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "binary" });

          // Assuming the first sheet is the one you want to convert
          const sheetName = workbook.SheetNames[0];
          const sheetData = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          // console.log(sheetData)
          setJsonResult(sheetData);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          console.error("Error converting Excel to JSON:", error);
        }
      };

      reader.readAsBinaryString(file);
    }

    setIcon(
      "data:image/png;base64,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"
    );
  }

  const onClose = () => {
    setShowModal(false);
  };

  const onOpen = () => {
    setShowModal(true);
  };

  function isKeyInArray(array, key) {
    return array.some((obj) => obj.hasOwnProperty(key));
  }

  const _ONSUBMIT = () => {
    if (
      !(isKeyInArray(jsonResult, "key") && isKeyInArray(jsonResult, "value"))
    ) {
      toast.error("Please upload valid file");
      return;
    }

    importGL(jsonResult, (res) => {
      getGLDataList();
      onClose();
      toast.success(res.message);
    });
  };

  const handleUpdate = async () => {
    const data = {
      GlId: editId,

      key: glData.key,
      value: glData.value,
    };
    setIsLoading(true);
    try {
      const response = await instance.post(`/customer/gl/edit-gl`, data);
    //  console.log("submitData", response);
      toast.success(response?.data?.message);
      getGLDataList();
      handleCloseEdit();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    //  console.log("errrrr---->", err);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain glbg">
        <Leftpanel breadcm={t("other")} />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={`${t("configuration")} > ${t("other")} > ${t(
              "accounting_keys"
            )}`}
            description=""
          />
          <div className="commonBase mb-4">
            <div className="dbtableTop">
              <div className="dbSearch">
                {/* <input type="search" className='form-control' placeholder={t('search')} />
                        <i className="fa-solid fa-magnifying-glass"></i> */}
              </div>
              <div className="dbtableSrchbg">
                <button className="commonButton" onClick={handleShow}>
                  <Link to="">
                    <i className="fa-solid fa-plus"></i> {t("add_gl_key")}
                  </Link>
                </button>
                &nbsp;
                <button className="commonButton" onClick={onOpen}>
                  <Link to="">
                    <i className="fa-solid fa-plus"></i> {t("import_gl_key")}
                  </Link>
                </button>
              </div>
            </div>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("key")}</th>
                    <th>{t("description")}</th>
                    {/* <th>Status</th> */}
                    {/* <th>&nbsp;</th> */}
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}
                <tbody>
                  {currentPageData.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td data-label={t("key")}>{item.key}</td>
                        <td data-label={t("description")}>{item.value}</td>
                        <td data-label="Action">&nbsp;</td>
                        <td>
                          <Link to="">
                            <i
                              className="fa-light fa-pen"
                              onClick={() => handleEdit(item?.id)}
                            ></i>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>

          {/* Modal for Editing GL Key */}
          <Modal show={editModal} onHide={handleCloseEdit} centered>
            <Modal.Header closeButton>
              <Modal.Title>{t("edit_gl")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">
                  {t("enter_gl_key")}
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={glData.key}
                    onChange={(e) =>
                      setGlData({ ...glData, key: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">
                  {t("enter_gl_description")}
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={glData.value}
                    onChange={(e) =>
                      setGlData({ ...glData, value: e.target.value })
                    }
                  />
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="primary"
                className="commonButton"
                onClick={handleUpdate}
              >
                {t("update")}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal for Adding GL Key */}
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>{t("add_gl_key")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">
                  {t("enter_gl_key")}
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={glData.key}
                    onChange={(e) =>
                      setGlData({ ...glData, key: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">
                  {t("enter_gl_description")}
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={glData.value}
                    onChange={(e) =>
                      setGlData({ ...glData, value: e.target.value })
                    }
                  />
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="primary"
                className="commonButton"
                onClick={_SUBMIT_ADD}
              >
                {t("add")}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal for Importing GL Key */}
          <Modal show={showModal} onHide={onClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>{t("import_gl_key")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">
                  {t("Enter Excel file")}
                </label>
                <div className="col-sm-8">
                  <div className="customFile">
                    <span>{t("sample_document")}: </span>
                    <label htmlFor="file-upload" className="custom-file-upload">
                      {file ? file.name : "No file chosen..."}
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      onChange={handleChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="primary" className="commonButton">
                <a
                  href={
                    `${APP_URL}/sample_sheet/GL1.xlsx`
                  }
                >
                  {t("sample_document")}
                </a>
              </Button>
              <Button
                variant="primary"
                className="commonButton"
                onClick={_ONSUBMIT}
              >
                {t("upload")}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default GL;
